import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

const CourseUnavailable = () => {
  const intl = useIntl();
  return (
    <div className="status-page status-page--error">
      <div className="legatum-container the-course">
        <div className="status-content">
          <h2 className="status-title">
            {intl.formatMessage(messages.pageTitle)}
          </h2>
          <p className="status-message">
            {intl.formatMessage(messages.mainMessage)}
          </p>
          <p className="status-info">
            {intl.formatMessage(messages.additionalInfo)}
          </p>
          <div className="action-buttons">
            <Link to="/course-catalogue" className="primary-btn">
              {intl.formatMessage(messages.browseCatalogue)}
            </Link>
            <Link to="/" className="return-home-btn">
              {intl.formatMessage(messages.returnHome)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseUnavailable;
